var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useEffect, useState } from 'react';
import debounce from 'lodash.debounce';
export var useDebouncedSearch = function (initialQuery, debounceTime, onQueryChange) {
    if (debounceTime === void 0) { debounceTime = 250; }
    var _a = __read(useState(''), 2), searchQuery = _a[0], setSearchQuery = _a[1];
    useEffect(function () {
        setSearchQuery(initialQuery);
    }, [setSearchQuery, initialQuery]);
    var inputHandler = useCallback(function (e, clear) {
        onQueryChange === null || onQueryChange === void 0 ? void 0 : onQueryChange(e, clear);
    }, [onQueryChange]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var debouncedInputHandler = useCallback(debounce(inputHandler, debounceTime, { trailing: true }), [inputHandler]);
    function handleQueryChange(e, clear) {
        var searchTerm = clear ? '' : e.target.value;
        setSearchQuery(searchTerm);
        debouncedInputHandler(e, clear);
    }
    return {
        searchQuery: searchQuery,
        handleQueryChange: handleQueryChange,
        setSearchQuery: setSearchQuery,
    };
};
